<template>
	<v-container>
		<v-row dense>
			<v-col cols="6">
				<v-btn depressed x-large block :color="colorBotonReiniciar" @click="reiniciar" class="text-subtitle-1">
					<v-icon>
						delete
					</v-icon>
				</v-btn>
			</v-col>
			<v-col cols="6">
				<v-btn depressed x-large block :color="colorBotonRetroceder" @click="retroceder" class="text-subtitle-1">
					<v-icon>
						backspace
					</v-icon>
				</v-btn>
			</v-col>
		</v-row>
		<v-row dense>
			<v-col cols="4" v-for="digito in digitos">
				<v-btn depressed x-large block :color="colorBotonDigito" @click="insertarCaracter(digito)" class="text-subtitle-1">
					{{ digito }}
				</v-btn>
			</v-col>
			<v-col cols="8">
				<v-btn depressed x-large block color="success" @click="emitir" class="text-subtitle-1" :loading="cargando" :disabled="!puedeEmitir">
					Emitir
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import * as mathJs from 'mathjs';

// MathJS
const math = mathJs.create(mathJs.all);

// Caracteres del alfabeto aceptado por autómata de calculadora
const CERO = '0', UNO ='1', DOS = '2', TRES = '3', CUATRO = '4', CINCO = '5', SEIS = '6', SIETE = '7', OCHO = '8', NUEVE = '9';
const VACIO = '';

// Conjuntos de caracteres
const DIGITOS0 = [CERO]; // D₀={0}
const DIGITOS19 = [UNO, DOS, TRES, CUATRO, CINCO, SEIS, SIETE, OCHO, NUEVE]; // D₁₉={1,2,3,...,8,9}
const DIGITOS = DIGITOS0.concat(DIGITOS19); // D=D₀∪D₁₉={0,1,2,...,8,9}

// Estados del autómata
const ESPERANDO_D19 = 0;
const ESPERANDO_D = 1;
const ESTADO_INICIAL = ESPERANDO_D;

const MONTO_INICIAL = 0;


export default {
	components: {
		// Nada por ahora
	},
	props: {
		inhibirTeclado: {
			type: Boolean,
			default: undefined,
		},
		cargando: {
			type: Boolean,
			default: undefined,
		},
		puedeEmitir: {
			type: Boolean,
			default: undefined,
		},
	},
	data () {
		return {
			// Calculadora
			monto: MONTO_INICIAL,
			// Autómata
			entrada: VACIO,
			digitos: [SIETE, OCHO, NUEVE, CUATRO, CINCO, SEIS, UNO, DOS, TRES, CERO], // En el orden en que parecerán en botonera
			pilaEstados: [ESTADO_INICIAL],
			// Botonera
			colorBotonRetroceder: 'amber lighten-4',
			colorBotonReiniciar: 'red lighten-4',
			colorBotonDigito: 'green lighten-4',
			colorBotonSeparador: 'grey lighten-2',
			colorBotonOperacion: 'grey lighten-2',
			colorBotonIgual: 'grey lighten-2',
		};
	},
	computed: {
		hayEntrada: function() {
			let vm = this;
			let entrada = vm.entrada;
			let hay = (entrada !== VACIO);
			return hay;
		},
		estado: function() {
			let vm = this;
			// Hay compromiso de que la pila nunca quedará vacía
			let alturaPila = vm.pilaEstados.length;
			let estado = vm.pilaEstados[alturaPila - 1];
			return estado;
		},
	},
	methods: {
		//////////////////////////////
		// Calculadora
		retroceder: function() {
			let vm = this;
			let entrada = vm.entrada;
			let nuevaEntrada = entrada.slice(0, -1);
			let alturaPilaEstados = vm.alturaPilaEstados();
			if(alturaPilaEstados > 1) { // Se tiene: altura=1 ⇒ (pila=[ESTADO_INICIAL] ∧ nuevaEntrada=VACIO)
				vm.desapilarEstado(); // Dar un paso atrás
			}
			vm.entrada = nuevaEntrada;
		},
		reiniciar: function() {
			let vm = this;
			vm.reiniciarPilaEstados();
			vm.entrada = VACIO;
			vm.monto = MONTO_INICIAL; // Reiniciar monto también
		},
		igual: function(entrada) {
			let vm = this;
			if(entrada === VACIO) {
				vm.monto = MONTO_INICIAL;
				return;
			}
			
			let nuevaEntrada;
			try {
				// Intentar evaluar, retorna número
				nuevaEntrada = math.evaluate(entrada);
			}
			catch(e) {
				// Terminar, nada más que hacer. Evaluación no es válida como monto.
				return;
			}
			
			// Reiniciar pila de estados. Hacer transiciones para dejarla
			// en el estado que le corresponde.
			let cadenaNuevaEntrada = nuevaEntrada.toString();
			vm.reiniciarPilaEstados();
			cadenaNuevaEntrada.toString().split('').forEach(vm.insertarCaracter);
			vm.entrada = cadenaNuevaEntrada.toString();
			vm.monto = nuevaEntrada; // Guardar nuevo monto
		},
		emitirMonto: function(monto) {
			let vm = this;
			vm.$emit('monto', monto);
		},
		emitirEntrada: function(entrada) {
			let vm = this;
			vm.$emit('entrada', entrada);
		},
		listenerTeclado: function(event) {
			let vm = this;
			
			let inhibir = vm.inhibirTeclado;
			if(inhibir) {
				return;
			}
			
			let codigo = event.keyCode;
			let codigoRetroceso = 8;
			let codigoSuprimir = 46;
			
			let mapaCaracteres = {  
				96: () => vm.insertarCaracter(CERO), 97: () => vm.insertarCaracter(UNO), 98: () => vm.insertarCaracter(DOS),
				99: () => vm.insertarCaracter(TRES), 100: () => vm.insertarCaracter(CUATRO), 101: () => vm.insertarCaracter(CINCO),
				102: () => vm.insertarCaracter(SEIS), 103: () => vm.insertarCaracter(SIETE), 104: () => vm.insertarCaracter(OCHO),
				105: () => vm.insertarCaracter(NUEVE), [codigoRetroceso]: vm.retroceder, [codigoSuprimir]: vm.reiniciar,
			};
			
			if(codigo in mapaCaracteres) {
				let accion = mapaCaracteres[codigo];
				accion();
			}
		},
		
		//////////////////////////////
		// Autómata
		esDigito: function(caracter){
			return DIGITOS.includes(caracter);
		},
		esDigito0: function(caracter){
			return DIGITOS0.includes(caracter);
		},
		esDigito19: function(caracter){
			return DIGITOS19.includes(caracter);
		},
		insertarCaracter: function(caracter) {
			let vm = this;
			let entrada = vm.entrada;
			let puedeInsertar = vm.transicion(caracter);
			if(puedeInsertar) {
				let nuevaEntrada = `${entrada}${caracter}`;
				vm.entrada = nuevaEntrada;
			}
		},
		transicion: function(caracter) {
			// Retorna true si pudo hacer transición (⇔ carácter es correcto) o false si no.
			let vm = this;
			let estadoActual = vm.estado;
			let transicionRealizada = false;
			if(estadoActual === ESPERANDO_D19) {
				if(vm.esDigito19(caracter)) {
					vm.apilarEstado(ESPERANDO_D);
					transicionRealizada = true;
				}
			}
			else if(estadoActual === ESPERANDO_D) {
				if(vm.esDigito(caracter)) {
					vm.apilarEstado(ESPERANDO_D);
					transicionRealizada = true;
				}
			}
			return transicionRealizada;
		},
		apilarEstado: function(estado) {
			let vm = this;
			vm.pilaEstados.push(estado);
		},
		desapilarEstado: function() {
			let vm = this;
			let alturaPilaEstados = vm.alturaPilaEstados();
			if(alturaPilaEstados === 1) {
				throw 'Pila no puede quedar vacía';
			}
			let estadoDesapilado = vm.pilaEstados.pop();
			return estadoDesapilado;
		},
		reiniciarPilaEstados: function() {
			let vm = this;
			vm.pilaEstados = [ESTADO_INICIAL];
		},
		alturaPilaEstados: function(){
			let vm = this;
			let altura = vm.pilaEstados.length;
			return altura;
		},
		emitir: function() {
			let vm = this;
			vm.$emit('emitir');
		},

		//////////////////////////////
		// Notificaciones
		notificarAlerta: function(mensaje) {
			let vm = this;
			vm.$emit('alerta', mensaje);
		},
		notificarError: function(mensaje) {
			let vm = this;
			vm.$emit('error', mensaje);
		},
		notificarExito: function(mensaje) {
			let vm = this;
			vm.$emit('exito', mensaje);
		},
	},
	watch: {
		entrada: function(nuevaEntrada) {
			let vm = this;
			vm.emitirEntrada(nuevaEntrada);
			vm.igual(nuevaEntrada); // Evaluar inmediatamente
		},
		monto: function(nuevoMonto) {
			let vm = this;
			vm.emitirMonto(nuevoMonto);
		},
	},
	mounted: function() {
		let vm = this;
		// Conectar teclado
		window.addEventListener('keydown', vm.listenerTeclado);
		vm.emitirMonto(MONTO_INICIAL);
		vm.emitirEntrada(VACIO);
	},
	beforeDestroy: function() {
		let vm = this;
		// Desconectar teclado
		window.removeEventListener('keydown', vm.listenerTeclado);
	},
	created: function() {
		// Nada por ahora
	},
};
</script>
